<template>
  <div>
    HEADER for FMC sessions that includes link back to base, login. IMPORTANT - this should also get the login information like profileID<br/>
    WIP for creating new sessions. <br/>
    Include new session link. <br/>
    Include join session link (given sessionID). <br/>
    Include spectate session link (this means we need auth? for trial run, assume only admins will use spectate) <br/>
    <v-btn @click='newSession'>NEW SESSION</v-btn>
    <v-text-field v-model='solveTime' number></v-text-field>
  </div>
</template>

<script>
import FMCService from '@/services/FMCService'

export default {
  name: 'fmc-base',
  data () {
    return {
      solveTime: 300000,
    }
  },
  methods: {
    async newSession () {
      const {data} = await FMCService.newSession({
        solveTime: this.solveTime,
      })
      if (data.error) {
        alert(`Error: ${data.error} - ${data.message}`)
        return
      }

      this.$router.push({ path: `/fmc/session/${data.sessionID}`, params: { sid: data.sessionID }})
    }
  }
}
</script>

<style scoped>
</style>
